import { Button, CircularProgress } from '@mui/material'
import React, { FunctionComponent } from 'react'
import { createStripeCheckoutSession } from '../../../services/api-requests/api-request'
import { loadStripe } from '@stripe/stripe-js'
import CreditIcon from '@mui/icons-material/CreditCardOutlined'
import { envConfig } from '../../../services/envConfig'

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const STRIPE_PUBLIC_KEY = envConfig.NEXT_PUBLIC_STRIPE_KEY || ''
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

interface IPayWithStripeProps {
  text?: string
  disabled?: boolean
  currency: string
  email: string
  amount: number
  success_url: string
  cancel_url: string
  product_name: string
  metadata: any
  buttonVariant?: 'contained' | 'outlined' | 'text'
}
const PayWithStripe: FunctionComponent<IPayWithStripeProps> = (
  props: IPayWithStripeProps,
) => {
  const [paymentLoading, setPaymentLoading] = React.useState(false)

  const {
    email,
    metadata,
    product_name,
    success_url,
    cancel_url,
    amount,
    currency,
  } = props

  const handleClick = async (_event: any) => {
    const stripe = await stripePromise
    try {
      setPaymentLoading(true)
      const axiosRes = await createStripeCheckoutSession(
        email,
        metadata,
        success_url,
        cancel_url,
        amount,
        currency,
        product_name,
      )
      setPaymentLoading(false)
      console.log('stripe session', axiosRes)
      const session = axiosRes.data.data

      if (!stripe) {
        throw new Error('Unable to load stripe')
      }

      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      })

      metadata.close()
      metadata.EditCouponRequest({
        code: metadata.code,
        usage_count: metadata.usage - 1,
      })

      if (result.error) {
        metadata.EditCouponRequest({
          code: metadata.code,
          usage_count: metadata.usage - 1,
        })
        console.log(
          'Error getting checkout session result result.error',
          result.error,
        )
        throw new Error('Error getting checkout session result')
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
      }
    } catch (e) {
      setPaymentLoading(false)
      console.log('error setting up stripe session', e)
    }
  }

  return (
    <Button
      color="primary"
      variant={props.buttonVariant || 'contained'}
      size="large"
      fullWidth={true}
      onClick={handleClick}
      disabled={props.disabled || paymentLoading}
      disableElevation={true}
    >
      <CreditIcon style={{ marginRight: '5px' }} />
      {props.text || 'Make Payment'}
      {paymentLoading && <CircularProgress size={20} />}
    </Button>
  )
}

export default PayWithStripe
